interface MasteryBarProps {
  /** 0–100, or null when a topic has never been attempted. */
  mastery: number | null;
  weak?: boolean | undefined;
}

/**
 * A topic's mastery.
 *
 * `null` renders as "not started" rather than 0%, for the same reason the ring
 * does: never practised and practised badly are different facts, and conflating
 * them tells a student something untrue about themselves.
 */
export function MasteryBar({ mastery, weak = false }: MasteryBarProps) {
  if (mastery === null) {
    return <span className="text-[11.5px] text-text-muted">not started</span>;
  }

  return (
    <div className="flex items-center gap-2">
      <div className="h-1.5 w-16 overflow-hidden rounded-[var(--radius-chip)] bg-surface-high">
        <div
          className={`h-full rounded-[var(--radius-chip)] ${weak ? "bg-negative" : "bg-accent"}`}
          style={{ width: `${Math.min(100, Math.max(0, mastery))}%` }}
        />
      </div>
      <span className="tabular text-[11.5px] text-text-muted">{mastery}% mastery</span>
    </div>
  );
}
